export interface MoneyNavigationItem {
  key: 'home' | 'record' | 'history' | 'services' | 'team';
  href: string;
  labelKey: string;
  icon: string;
  end?: boolean;
  anyPermission?: readonly string[];
  shortLabelKey?: string;
}

export const MONEY_NAV_ITEMS: readonly MoneyNavigationItem[] = [
  { key: 'home', href: '/', labelKey: 'money.nav.home', icon: 'home', end: true },
  {
    key: 'record',
    href: '/money/record',
    labelKey: 'money.nav.record',
    shortLabelKey: 'money.nav.record',
    icon: 'add_circle',
    anyPermission: ['money.entries.record'],
  },
  { key: 'history', href: '/money/history', labelKey: 'money.nav.history', icon: 'receipt_long' },
  { key: 'services', href: '/money/services', labelKey: 'money.nav.services', icon: 'widgets' },
  { key: 'team', href: '/money/team', labelKey: 'money.nav.team', icon: 'group' },
];

export const moneyMobilePrimaryItems = MONEY_NAV_ITEMS.filter((item) => (
  item.key === 'home' || item.key === 'record' || item.key === 'history'
));

export const moneyMobileMoreItems = MONEY_NAV_ITEMS.filter((item) => (
  item.key === 'services' || item.key === 'team'
));
